import {
  CheckboxField,
  Theme,
  Typography,
  WysiwygEditorField,
  createStyles,
  makeStyles,
} from '@forgeglobal/design-framework'
import React from 'react'

const useOfferingFormStyles = makeStyles(({ spacing }: Theme) =>
  createStyles({
    fieldItemFullWidth: {
      paddingRight: spacing(2),
    },
    fieldCheck: {
      flex: '0 50%',
      paddingLeft: spacing(2),
      paddingRight: spacing(2),
    },
  })
)

export const CampaignCustomText: React.FC<{ name: string; label: string; showCustomText: boolean | undefined }> = ({
  name,
  label,
  showCustomText,
}) => {
  const classes = useOfferingFormStyles()
  return (
    <>
      <div className={classes.fieldCheck}>
        <CheckboxField name={`use_${name}`} label={<Typography variant="subtitle2">{label}</Typography>} />
      </div>
      {showCustomText && (
        <div className={classes.fieldItemFullWidth}>
          <WysiwygEditorField name={name} />
        </div>
      )}
    </>
  )
}
